import React from "react";
import { Box, Typography, Paper, alpha, useTheme, Stack } from "@mui/material";
import { formatAmount } from "../../../../utils/hooks/dataHandler";
import TaxBox from "./TaxBox";

const Method2 = ({ method2Results, totalMethod2FTC }) => {
  const theme = useTheme();
  return (
    <>
      <TaxBox data={method2Results} formatAmount={formatAmount} />
      {/* Summary Card */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mt: 2,
          borderRadius: 2,
          backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.08),
          border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
        }}
      >
        <Stack direction='row' spacing={3} alignItems='center'>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant='subtitle2'
              sx={{
                fontWeight: 600,
                color: "secondary.main",
                fontSize: "0.9rem",
              }}
            >
              Total Summary
            </Typography>
            <Typography
              variant='body2'
              sx={{
                color: "text.secondary",
                fontSize: "0.8rem",
              }}
            >
              FTC Pooling
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 3 }}>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant='caption'
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  display: "block",
                }}
              >
                Total SG Tax
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  fontWeight: 500,
                  fontSize: "0.85rem",
                }}
              >
                {formatAmount(
                  method2Results.reduce(
                    (sum, r) => sum + Number(r.singaporeTax),
                    0
                  ),
                  false
                )}
              </Typography>
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant='caption'
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  display: "block",
                }}
              >
                Total Foreign Tax
              </Typography>
              <Typography
                variant='body2'
                sx={{
                  fontWeight: 500,
                  fontSize: "0.85rem",
                }}
              >
                {formatAmount(
                  method2Results.reduce(
                    (sum, r) => sum + Number(r.foreignTax),
                    0
                  ),
                  false
                )}
              </Typography>
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant='caption'
                sx={{
                  color: "secondary.main",
                  fontSize: "0.7rem",
                  display: "block",
                  fontWeight: 600,
                }}
              >
                Total FTC
              </Typography>
              <Typography
                variant='h6'
                sx={{
                  fontWeight: 700,
                  color: "secondary.main",
                  fontSize: "1.1rem",
                }}
              >
                {formatAmount(totalMethod2FTC, false)}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Paper>
    </>
  );
};

export default Method2;
